import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../font-scale-categories.css";
const Overline = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    as: ComponentToRender,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    ref: ref,
    className: `${className} ${styles.overline}`
  }, props));
});
Overline.defaultProps = {
  className: '',
  as: 'div'
};
Overline.propTypes = {
  /**
   * Additional classes to apply
   */
  className: PropTypes.string,
  /**
   * Component to render
   */
  as: PropTypes.elementType
};
export default Overline;